import {useEffect, useState} from 'react'
import {TableComponent} from '../../../../../_metronic/partials/widgets'
import {SearchInput} from '../../../../components'
import {CustomerTableColumn, RemoveAccents} from '../../../../utils'
import {searchAndPagingUser} from '../../../../modules/insurance/healthInsurance/apis'
import {CustomerTypeEnums} from '../../../../enums'
import {Button} from '@mui/material'
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined'

type Props = {
  handleCustomerSelected: (data: string[]) => void
  customerSelected: string[]
}

const FormChooseCustomer = ({handleCustomerSelected, customerSelected}: Props) => {
  const [selectedRow, setSelectedRow] = useState<any>([])
  const [selectedRowOrigin, setSelectedRowOrigin] = useState<any>([])
  const [rows, setRows] = useState<any>([])
  const [page, setPage] = useState(1)
  const [rowPerPage, setRowPerPage] = useState(20)
  const [valueFilter, setValueFilter] = useState('')
  const [totalRows, setTotalRows] = useState(0)
  const [loading, setLoading] = useState(true)

  const handleFilterUser = (value: string) => {
    setValueFilter(value)
    filterUser(undefined, undefined, value)
  }

  const handleOnChangePage = (page: number) => {
    setLoading(true)
    setPage(page)
    if (valueFilter) filterUser(page.toString(), rowPerPage.toString(), valueFilter)
    else filterUser(page.toString())
  }

  const handleChangeRowPerPage = (row: number) => {
    setLoading(true)
    setRowPerPage(row)
    if (valueFilter) filterUser(page.toString(), row.toString(), valueFilter)
    else filterUser(page.toString())
  }

  const handleGetSelectedRow = (data: any) => {
    setSelectedRow(data)
  }

  const filterUser = (pageNum?: string, pageSize?: string, filterName?: string) => {
    if (!loading) setLoading(true)
    let filter: any = {
      Page: pageNum ? pageNum : page.toString,
      PageSize: '999',
      Filters: [
        {
          FieldName: 'CustomerType',
          Comparision: '==',
          FieldValue: 1,
        },
      ],
    }
    if (filterName) {
      let object = {
        FieldName: 'Filter',
        Comparision: 'Contains',
        FieldValue: RemoveAccents(filterName),
      }
      filter.Filters.push(object)
    }
    searchAndPagingUser(filter)
      .then((res: any) => {
        if (res && !res.isError) {
          res.data.items.forEach((elem: any) => {
            elem.customerType = CustomerTypeEnums.find((c) => c.value == elem.customerType)?.label
          })
          setLoading(false)
          setRows(res.data.items)
          setTotalRows(res.data.totalItems)
        }
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const handleChooseCustomer = () => {
    let arr: string[] = []
    selectedRow.forEach((elem: any) => {
      let customer = rows.find((o: any) => o.id == elem)
      if (customer) {
        arr.push(customer.customerCode)
      }
    })
    handleCustomerSelected(arr)
  }

  useEffect(() => {
    if (customerSelected.length > 0 && rows.length > 0) {
      let arr: any = []
      customerSelected.forEach((o) => {
        let test = rows.find((e: any) => e.customerCode == o)
        if (test) arr.push(test.id)
      })
      setSelectedRow(arr)
    }
  }, [customerSelected, rows])

  useEffect(() => {
    filterUser()
  }, [])

  return (
    <>
      <div className='tabel-feature-wrapper'>
        <SearchInput handleSearchValue={handleFilterUser} />
      </div>
      <TableComponent
        rowData={rows}
        column={CustomerTableColumn}
        heightTable='400px'
        handleClickRow={() => {}}
        handleOnChangePage={handleOnChangePage}
        // handleOnChangeRowPerPage={handleChangeRowPerPage}
        handleGetSelectedRow={handleGetSelectedRow}
        selectedRows={selectedRow}
        pageSize={rowPerPage}
        currentPage={page}
        loading={loading}
        totalRows={totalRows}
        showCheckBox
        // showPageSize
      />
      <div className='custom-modal-content-btn'>
        <Button
          onClick={handleChooseCustomer}
          size='small'
          variant='outlined'
          className='modal-footer-btn custom-form-feature-btn'
        >
          <SaveAltOutlinedIcon />
          Chọn
        </Button>
      </div>
    </>
  )
}

export {FormChooseCustomer}
